import axios from '../../../../utills/axiosConfig';

export const fetchUsers = async () => {
  const res = await axios.get('/users');
  return res.data;
};

export const addUser = async (user) => {
  try {
    const res = await axios.post('/users', user);
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.error || 'Failed to add user');
  }
};

export const updateUser = async (id, user) => {
  try {
    const res = await axios.put(`/users/${id}`, user);
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.error || 'Failed to update user');
  }
};

export const deleteUser = async (id) => {
  const res = await axios.delete(`/users/${id}`);
  return res.data;
}; 